import React from 'react';
import { Button, Grid, Typography } from '@mui/material';
import { ConfirmDeleteIcon } from '../../assets/images/UI-dashboard';
import CustomDialogWrapper from './CustomDialogWrapper/CustomDialogWrapper';

interface ConfirmationDialogProps {
  val?: string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({ val = 'Delete', open, onClose, onConfirm }) => {
  return (
    <CustomDialogWrapper open={open} onClose={onClose} width="552px" height="352px">
      <Grid>
        <Grid
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '15%',
          }}
        >
          <img style={{ width: '45px', height: '57.86px' }} src={ConfirmDeleteIcon} alt="confirm-delete" />
        </Grid>
        <Typography
          style={{
            fontSize: 16,
            fontWeight: 400,
            lineHeight: '19.5px',
            textAlign: 'center',
            marginTop: '15px',
          }}
        >
          Are you sure you want to {val}?
        </Typography>

        <Grid
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
            marginTop: '20px',
          }}
        >
          <Button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            sx={{
              color: 'white',
              width: '362px',
              height: '44px',
              marginBottom: '10px',
              fontSize: 14,
              '&:hover': {
                background: '#DF2020 !important',
                color: 'white',
              },
            }}
          >
            Yes
          </Button>
          <Button
            style={{
              border: '0.88px solid #E6E6E6',
              color: 'black',
              background: 'white',
              width: '362px',
              height: '44px',
            }}
            onClick={onClose}
            color="primary"
          >
            No
          </Button>
        </Grid>
      </Grid>
    </CustomDialogWrapper>
  );
};

export default ConfirmationDialog;
